export default __webpack_public_path__ + "0e46b654382755efac2fea40773abd0b.png";